module.exports = __webpack_public_path__ + "static/media/frost-flattened.536fef38.svg";